import { render, staticRenderFns } from "./reportsAdvisorAll.vue?vue&type=template&id=5cd7b0c8&scoped=true"
import script from "./reportsAdvisorAll.vue?vue&type=script&lang=js"
export * from "./reportsAdvisorAll.vue?vue&type=script&lang=js"
import style0 from "./reportsAdvisorAll.vue?vue&type=style&index=0&id=5cd7b0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7b0c8",
  null
  
)

export default component.exports